import { Observable } from 'rxjs';
import { get } from 'lodash';
import '../lib/modernizr';


export function isHLSSupported () {
    var mediaSourceSupported = (typeof window.MediaSource !== 'undefined');
    var canPlayNativeHLS = (!!document.createElement('video').canPlayType('application/vnd.apple.mpegURL'));

    return (mediaSourceSupported || canPlayNativeHLS);
}

export const isBot = () => /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

export function inIframe (checkDomain = false) {
    try {
        if (checkDomain) return !document.referrer.includes('adultswim.com') && (window.self !== window.top);
        else return window.self !== window.top;
    } catch (e) {
        return true;
    }
}


export function serialize (obj, prefix) {
    var str = [];
    for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + '[' + p + ']' : p,
                v = obj[p];
            str.push(typeof v === 'object' ?
                serialize(v, k) :
                encodeURIComponent(k) + '=' + encodeURIComponent(v));
        }
    }
    return str.join('&');
}


export const getMedia = (data) => get(data, 'media.desktop.unprotected') || get(data, 'media.desktop.bulkaes');


export const removeHostname = (url) => url.replace(/^.*\/\/[^\/]+/, '');


export function timecodeFromSeconds (time) {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time - minutes * 60);
    return minutes + ':' + (new Array(3).join('0') + seconds).slice(-2);
}


export function secondsFromTimecode (time) {
    const timeArray = time.split(':'); // optimized
    const parsed = timeArray.length > 1
        ? ((parseInt(timeArray[0], 10) * 60) + parseInt(timeArray[1], 10))
        : parseInt(timeArray[0], 10);

    return parsed || 0;
}


export function handleErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}


export function assignDefined(target, ...sources) {
    for (const source of sources) {
        for (const key of Object.keys(source)) {
            const val = source[key];
            if (val !== undefined) {
                target[key] = val;
            }
        }
    }
    return target;
}


export function modernizrDetect(feature) {
    return Observable.create(observer => {
        Modernizr.on(feature, result => {
            observer.next(result);
            observer.complete();
        });
    }).catch(() => Observable.of(false));
}

export function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
}


// WEBPACK FOOTER //
// ./src/utils/ASVPUtils.js